export const OnboardingActionTypes = {
  ONBOARDING_REGISTER_REQUEST: 'ONBOARDING_REGISTER_REQUEST',
  ONBOARDING_REGISTER_SUCCESS: 'ONBOARDING_REGISTER_SUCCESS',
  ONBOARDING_REGISTER_FAILURE: 'ONBOARDING_REGISTER_FAILURE',

  ONBOARDING_UPDATE_REQUEST: 'ONBOARDING_UPDATE_REQUEST',
  ONBOARDING_UPDATE_SUCCESS: 'ONBOARDING_UPDATE_SUCCESS',
  ONBOARDING_UPDATE_FAILURE: 'ONBOARDING_UPDATE_FAILURE',

  WIZARD_REGISTER_REQUEST: 'WIZARD_REGISTER_REQUEST',
  SET_WIZARD_REGISTER: 'SET_WIZARD_REGISTER',
  WIZARD_REGISTER_SUCCESS: 'WIZARD_REGISTER_SUCCESS',
  WIZARD_REGISTER_FAILURE: 'WIZARD_REGISTER_FAILURE',

  WIZARD_UPDATE_REQUEST: 'WIZARD_UPDATE_REQUEST',
  WIZARD_UPDATE_SUCCESS: 'WIZARD_UPDATE_SUCCESS',
  WIZARD_UPDATE_FAILURE: 'WIZARD_UPDATE_FAILURE',

  RESET_ONBOARDING: 'RESET_ONBOARDING',
};
